












import { Component, Vue, Prop } from "vue-property-decorator";
import AgroIcons from "@/components/agroIcons/AgroIcons.vue";
import ChangePasswordForm from "./components/change-password-form/ChangePasswordForm.vue";
import AgroNotificationList from "@/components/agroNotificationList/AgroNotificationList.vue";

@Component({
  name: "ChangePassword",
  components: {
    ChangePasswordForm,
    AgroNotificationList,
  },
})
export default class ChangePassword extends Vue {
  @Prop(String) private token?: string;
  private password!: string;


}
